import {
  ILoginState,
  initialState,
  LoginDispatchTypes,
  RESET_LOGIN,
  SEND_LOGIN,
  SEND_LOGIN_FAIL,
  SEND_LOGIN_SUCCESS,
  UPDATE_SOCIAL_TOKEN,
} from '.'

export const loginReducer = (state = initialState, action: LoginDispatchTypes): ILoginState => {
  switch (action.type) {
    case SEND_LOGIN:
      return {
        ...state,
        loginCompleted: false,
        error: null,
        isLoading: true,
      }
    case SEND_LOGIN_SUCCESS:
      return {
        ...state,
        loginCompleted: true,
        error: null,
        data: action.payload,
        isLoading: false,
      }
    case SEND_LOGIN_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    case UPDATE_SOCIAL_TOKEN:
      return {
        ...state,
        socialToken: action.payload,
      }
    case RESET_LOGIN:
      return {
        data: {
          accessToken: '',
          expiresIn: 0,
          refreshToken: '',
          success: false,
          tokenType: '',
        },
        socialToken: '',
        loginCompleted: false,
        isLoading: false,
        error: null,
      }

    default:
      return state
  }
}
